export default __webpack_public_path__ + "bf6244ed899d4ad9cd2ced0e65b28845.jpg";